/**
 * @version:               1.0.0
 * @createTime:            2021.10.08
 * @updateTime:            2021.10.08
 * @author:                zhangju
 * @description
 ***/

import ccTab from '@/components/common/tab/index.vue';
import contentTable from '@/components/common/more-tab-content/content-table/index.vue';
export default {
    name: 'page-list',
    components: {ccTab, contentTable},
    data() {
        return {
            tabList: [
                {
                    name: '调研文章',
                    code: 'dywz'
                },
                {
                    name: '审判年刊',
                    code: 'spnk'
                }
            ],
            active: 'dywz'
        };
    },
    computed: {
        crumbsList() {
            const list = [{
                name:'理论探讨',
                key:'lltt',
                path:'/lltt'
            }];
            const listItem = this.tabList.filter(item => item.code === this.active)[0];
            listItem.key = listItem.code;
            list.push(listItem);
            return Object.freeze(list);
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.active = this.$route.query.tab || 'dywz';
        },
        // 页签切换
        handelTabChange(code) {
            this.active = code;
        }
    }
};
